module.exports = __webpack_public_path__ + "1ffb84b0e8c61fa97cecf290471d6a1c.png";